import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

const breakePoints = {
    sDesktop: '1187px',
    tablet: '859px',
    mobile: '640px',
};

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);

export const FormContainer = styled.div`
    width: 100%;
    display:flex;
    flex-wrap: nowrap;
    padding: 50px 60px;
    background: ${COLORS.white};
    border: 1px solid ${COLORS.outlineGrey};
    box-sizing: border-box;
    border-radius: 4px;
    margin-bottom: 40px;
    @media (max-width: 1600px) {
        padding: 40px 60px;
    }
    @media (max-width: 1300px) {
        padding: 30px;
    }
    @media (max-width: 1000px) {
        flex-direction: column;
    }
    @media (max-width: 700px) {
        padding: 20px;
    }
`;
export const FormText = styled.div`
    border-right: 1px solid ${COLORS.grey};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 50%;
    padding-right: 4%;
    @media (max-width: 1300px) {
        width: 30%;
    }
    @media (max-width: 1000px) {
        width: 100%;
        padding-right: 0;
        border-right: 0;
        margin-bottom: 30px;
    }
`;
export const FormTitle = styled.div`
    ${FONTS.XXL};
    margin-bottom: 10px;
    width: 100%;
    @media (max-width: 1500px) {
        ${FONTS.L};
    }
`;
export const FormDesc = styled.div`
    ${FONTS.S};
    color: ${COLORS.darkGrey};
    width: 100%;
    @media (max-width: 1100px) {
        ${FONTS.XS};
    }
    @media (max-width: 800px) {
        ${FONTS.S};
    }
`;
export const FormRight = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;
    padding-left: 8%;
    @media (max-width: 1600px) {
        padding-left: 4%;
    }
    @media (max-width: 1300px) {
        width: 70%;
    }
    @media (max-width: 1000px) {
        width: 100%;
        padding-left: 0;
        justify-content: flex-start;
    }
`;

export const Name = styled(InputName)`
    flex: 1 1 100%;
    width: 100%;
    margin-right: ${p => p.isVertical ? '0' : '12px'};
    margin-bottom: 16px;

    @media (max-width: ${breakePoints.mobile}) {
        margin-right: 0;
    }
`;

export const Phone = styled(InputPhone)`
    flex: 1 1 100%;
    width: 100%;
    margin-bottom: 0;

    @media (max-width: ${breakePoints.mobile}) {
        margin-bottom: 16px;
    }
`;
